var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70px",
    height: "70px",
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "close") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 15,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-100.0%",
    y: "-100.0%",
    width: "300.0%",
    height: "300.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.10432146 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "List-&-pop-up-&-button",
    transform: "translate(-504.000000, -1395.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close",
    transform: "translate(524.000000, 1415.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("circle", {
    strokeOpacity: 0.2,
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "square",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    cx: 15,
    cy: 15,
    r: 14.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.7658775,19.6363601 L16.1298025,15.0002138 L20.7658597,10.3636039 C20.9170087,10.2124727 21.0001425,10.011529 21,9.79776668 C20.9998572,9.58464619 20.9168482,9.3845939 20.7662875,9.23446107 C20.6154951,9.08327637 20.4152288,9.0001248 20.2020727,9 C19.9880073,9 19.7872775,9.08313376 19.6362889,9.23406884 L15.0003388,13.8700369 L10.3636041,9.23406886 C10.212669,9.08313377 10.0120997,9 9.79883656,9 C9.58559128,9 9.38502196,9.08311593 9.23410469,9.2340332 C9.08322309,9.38450475 9.00014282,9.58464619 9,9.79776668 C8.99985756,10.011529 9.0829913,10.2124727 9.23410469,10.3635861 L13.8708037,15.0001959 L9.23408687,19.6363779 C9.08313394,19.787313 9,19.9878467 9,20.2011276 C9,20.4143729 9.08315178,20.61496 9.23410471,20.765913 C9.38502198,20.9168481 9.58557345,20.9999461 9.79881876,20.9999461 C10.0120819,20.9999461 10.212669,20.9168302 10.3635863,20.765913 L15.0002675,16.1298201 L19.6363781,20.765913 C19.7873132,20.9168481 19.9880608,20.9999461 20.2016092,20.9999461 C20.4153002,20.9998035 20.6153703,20.9168124 20.7655566,20.7662695 C21.0771967,20.4545937 21.0772859,19.9477685 20.7658775,19.6363601 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#000000",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.72286ece72b63b2665158d8da82ec2c1.svg";
export { ForwardRef as ReactComponent };